module.exports = __webpack_public_path__ + "static/img/03_01_trichorus.cd10c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/03_01_trichorus.png
// module id = g1g7
// module chunks = 12